/** Hero stat cards. */

import type { Totals } from '../lib/types';
import { el } from './dom';
import type { Formatters } from './format';

export function renderHero(container: HTMLElement, totals: Totals, savings: number, fmt: Formatters): void {
  container.replaceChildren(
    el(
      'div',
      { class: 'stat stat-savings' },
      el('div', { class: 'stat-label' }, 'Potential monthly savings'),
      el('div', { class: 'stat-value' }, fmt.money(savings)),
      el('div', { class: 'stat-sub' }, `${fmt.money(savings * 12)} / year if you act on the list below`),
    ),
    el(
      'div',
      { class: 'stat' },
      el('div', { class: 'stat-label' }, 'Monthly subscription spend'),
      el('div', { class: 'stat-value' }, fmt.money(totals.monthlyCost)),
      el('div', { class: 'stat-sub' }, `${fmt.money(totals.yearlyCost)} / year`),
    ),
    el(
      'div',
      { class: 'stat' },
      el('div', { class: 'stat-label' }, 'Active subscriptions'),
      el('div', { class: 'stat-value' }, String(totals.activeCount)),
      el('div', { class: 'stat-sub' }, totals.inactiveCount ? `${totals.inactiveCount} stopped / lapsed` : 'none stopped'),
    ),
  );
}
